module.exports = __webpack_public_path__ + "img/practitioner.33a6f13.png";